import { configureStore } from "@reduxjs/toolkit";
import accountReducer from "./reducers/accounts/account.reducer";
import categoryReducer from "./reducers/products/categories/category.reducer";
import attributeReducer from "./reducers/products/attributes/attribute.refucer";
import productReducer from "./reducers/products/product.reducer";
import shoppingCartReducer from "./slices/shoppingCart/shoppingCart.slice";
import websiteConfigurationReducer from "./reducers/websiteConfigurations/websiteConfiguration.reducer";
import orderReducer from "./reducers/orders/order.reducer";

const store = configureStore({
  reducer: {
    accountReducer: accountReducer, // Use a key to identify this slice of the state
    categoryReducer: categoryReducer, // Use a key to identify this slice of the state
    attributeReducer: attributeReducer, // Use a key to identify this slice of the state
    productReducer: productReducer, // Use a key to identify this slice of the state
    shoppingCart: shoppingCartReducer,
    websiteConfigurationReducer: websiteConfigurationReducer,
    orderReducer: orderReducer,
  },
});

export default store;
